import React from "react";

export default function RepeatSelect({
  elem,
  typeVisited,
  data,
  onChangeData,
  manualDocumentInfo,
}) {
  return (
    <div className="mb-2">
      <label for="nombre">
        {elem.label}
        <span className="obligatory"> *</span>
      </label>
      <select
        className={`${
          typeVisited ? (data?.entryType ? "" : "formError") : ""
        } selector form-select form-select-sm especialGroup shadow-sm formHover selectHeight`}
        name={elem.id}
        id={elem.id}
        onChange={(e) => {
          onChangeData(e.target.value, e.target.id);
        }}
      >
        {elem.options.map((elem, index) => {
          if (index < 1) {
            return (
              <option
                className="hiddenSelected"
                disabled
                selected
                hidden
                key={index}
                value={elem?.values}
              >
                {elem?.option}
              </option>
            );
          }
          return (
            <option
              key={index}
              value={elem?.values}
              selected={
                manualDocumentInfo?.selected &&
                manualDocumentInfo?.selected[0]?.document?.meta?.interval ===
                  elem.values
                  ? true
                  : false
              }
            >
              {elem?.option}
            </option>
          );
        })}
      </select>
    </div>
  );
}
